import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ToastController, AlertController, ModalController, createAnimation, AnimationController } from '@ionic/angular';
import { ModalAlertProp, ModalConfirmationProps, NotificationConfig, NotificationTypeEnum, ToastOptions } from '../models/config-view-models';
import { ConfirmationModalComponent } from '../components/util/confirmation-modal/confirmation-modal.component';
import { AlertModalComponent } from '../components/util/alert-modal/alert-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private renderer: Renderer2;

  constructor(
    private toastController: ToastController,
    private alertController: AlertController,
    private modalController: ModalController,
    private animationCtrl: AnimationController,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);

  }
  showSpinner(targetOrSelector?: HTMLElement | string) {
    const target = typeof targetOrSelector === 'string'
      ? document.querySelector<HTMLElement>(targetOrSelector) ?? document.body
      : (targetOrSelector ?? document.body);

    this.showSpinnerInternal(target, '/assets/images/Q-Coin-Spin.gif');
  }

  hideSpinner(containerElement?: HTMLElement | string) {
    const host = typeof containerElement === 'string'
      ? document.querySelector<HTMLElement>(containerElement) ?? document.body
      : (containerElement ?? document.body);

    host.querySelectorAll('.spinner-overlay').forEach((overlay: Element) => this.renderer.removeChild(host, overlay));
  }

  showSpinnerInternal(target: HTMLElement, spinnerSrc: string) {
    this.hideSpinner(target);

    const overlay = this.renderer.createElement('div');
    this.renderer.addClass(overlay, 'spinner-overlay');
    this.renderer.setStyle(overlay, 'backdrop-filter', 'blur(1px)');
    this.renderer.setStyle(overlay, '-webkit-backdrop-filter', 'blur(1px)');

    const spinnerContainer = this.renderer.createElement('div');
    this.renderer.addClass(spinnerContainer, 'spinner-container');

    const spinnerImage = this.renderer.createElement('img');
    this.renderer.setAttribute(spinnerImage, 'src', spinnerSrc);
    this.renderer.addClass(spinnerImage, 'spinner-image');

    const loadingText = this.renderer.createElement('p');
    this.renderer.addClass(loadingText, 'loading-text');
    this.renderer.appendChild(loadingText, this.renderer.createText('Loading...'));

    this.renderer.appendChild(spinnerContainer, spinnerImage);
    this.renderer.appendChild(spinnerContainer, loadingText);
    this.renderer.appendChild(overlay, spinnerContainer);

    if (target !== document.body) {
      this.renderer.addClass(overlay, 'container-specific');
      this.renderer.setStyle(overlay, 'position', 'absolute');
      this.renderer.setStyle(overlay, 'inset', '0');
      this.renderer.setStyle(overlay, 'z-index', '1');
    } else {
      this.renderer.setStyle(overlay, 'background', 'rgba(0, 0, 0, 0.18)');
      this.renderer.setStyle(loadingText, 'color', 'white');
    }

    this.renderer.appendChild(target, overlay);
  }

  async presentToast(options: ToastOptions/*,timeIbMs?: number*/) {
    const duration = options.persistent ? 0 : (options.timeInMs ?? 6000);
    const toast = await this.toastController.create({
      message: options?.message,
      duration,
      position: 'top',
      cssClass: [NotificationConfig[options?.notificationType]?.cssClass, "dynamic-toast"],
      header: options?.notificationType,
      icon: NotificationConfig[options?.notificationType]?.icon,
      animated: true,
      buttons: [
        {
          side: 'end',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            if (!!options.onDismissCallback)
              options.onDismissCallback();
          },
        },
      ],


    });
    // If user dismisses by timeout (non-persistent), still call callback:
    toast.onDidDismiss().then(() => {
      if (!!options.onDismissCallback)
        options.onDismissCallback();
    });
    await toast.present();
  }



  async presentConfirmationModal(props: ModalConfirmationProps) {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        modalProps: props
      },
      cssClass: "dynamic-confirmation-modal",
      backdropDismiss: false,

    });

    return await modal.present();
  }
  async presentAlertModal(props: ModalAlertProp): Promise<HTMLIonModalElement> {
    const modal = await this.modalController.create({
      component: AlertModalComponent,
      componentProps: {
        modalProps: props
      },
      cssClass: ["dynamic-alert-modal", NotificationConfig[props.notificationType].cssClass],
    });
    await modal.present()
    return modal;
  }

  async PresentTypedToast(message: string, notificationType: NotificationTypeEnum, timeIbMs?: number, onDismissCallback?: Function, persistent?: boolean) {
    var successToastOpt: ToastOptions = { notificationType: notificationType, message: message, timeInMs: timeIbMs, onDismissCallback: onDismissCallback, persistent: persistent };
    await this.presentToast(successToastOpt)
  };
  async PresentErrorAlertModal(header, message, callback?: Function) {
    var errorModalProps: ModalAlertProp = {
      header: header, message: message,
      onConfirmation: () => {
        if (!!callback)
          callback();
      },
      notificationType: NotificationTypeEnum.Error
    }

    await this.presentAlertModal(errorModalProps)
  };
}
